export default __webpack_public_path__ + "static/Litepaper - Greek-bce3400c808626ba44a3ec9ee9abd8f3.pdf";